/**
 * @overview: Types of actions to reduce with. These are defined
 * in a common enum so multiple reducers can operate on the same
 * action types.
 */

enum ActionTypes {
	/* ==== Config Actions === */

	// load entire config from external source
	CONFIG_LOAD_SUCCESS = "CONFIG_LOAD_SUCCESS",

	// saved entire config to external source
	CONFIG_SAVE_SUCCESS = "CONFIG_SAVE_SUCCESS",

	// add global config object to config store, replaces if existing
	CONFIG_GLOBAL_ADD = "CONFIG_GLOBAL_ADD",

	// add panel specific config object to config store, replaces if existing
	CONFIG_PANEL_ADD = "CONFIG_PANEL_ADD",

	// remove panel specific config object to config store
	CONFIG_PANEL_REMOVE = "CONFIG_PANEL_REMOVE",

	// add views specific config object scoped to a panel to config store, replaces if existing
	CONFIG_PANEL_VIEW_ADD = "CONFIG_PANEL_VIEW_ADD",

	// removes views specific config object scoped to a panel to config store
	CONFIG_PANEL_VIEW_REMOVE = "CONFIG_PANEL_VIEW_REMOVE",

	// add view specific config object to config store, replaces if existing
	CONFIG_VIEW_ADD = "CONFIG_VIEW_ADD",

	// remove view specific config object to config store
	CONFIG_VIEW_REMOVE = "CONFIG_VIEW_REMOVE",

	// duplicate an existing  view variant with a new key
	CONFIG_VIEW_CLONE = "CONFIG_VIEW_CLONE",

	// toggle displaying a box view arround the panel
	CONFIG_PANEL_BORDER_TOGGLE = "CONFIG_PANEL_BORDER_TOGGLE",

	// add a theme refrence
	CONFIG_PROPERTY_ADD = "CONFIG_PROPERTY_ADD",

	// 'ditions
	CONFIG_CONDITION_ADD = "CONFIG_CONDITION_ADD",

	CONFIG_CONDITION_REMOVE = "CONFIG_CONDITION_REMOVE",

	/* ==== Dictionary Actions === */

	// load entire dictionary from external source
	DICTIONARY_LOAD_SUCCESS = "DICTIONARY_LOAD_SUCCESS",

	DICTIONARY_ENTRIES_ADD = "DICTIONARY_ENTRIES_ADD",

	DICTIONARY_ENTRY_ADD = "DICTIONARY_ENTRY_ADD",

	DICTIONARY_ENTRY_REMOVE = "DICTIONARY_ENTRY_REMOVE",

	DICTIONARY_LANGUAGE_SET = "DICTIONARY_LANGUAGE_SET",

	/* ==== Resource Loader Actions === */

	RESOURCE_LOAD_SUCCESS = "RESOURCE_LOAD_SUCCESS",

	/* === Active Panel & View Actions. Lets editor know whats currently rendered */

	ACTIVE_PANEL_ADD = "ACTIVE_PANEL_ADD",

	ACTIVE_PANEL_REMOVE = "ACTIVE_PANEL_REMOVE",

	ACTIVE_VIEW_ADD = "ACTIVE_VIEW_ADD",

	ACTIVE_VIEW_REMOVE = "ACTIVE_VIEW_REMOVE",

	// panel global state. in active reducer for now but will move to a dedicated one soon
	SET_GLOBAL_PANEL_STATE = "SET_GLOBAL_PANEL_STATE",

	SET_TRACK_PAGINATION = "SET_TRACK_PAGINATION",

	/* === Schema Actions === */

	// using react-registry instead of redux for these now

	/* SCHEMA_PANEL_REGISTER,

	SCHEMA_PANEL_VIEW_REGISTER,

	SCHEMA_VIEW_REGISTER, */

	/* === Layout Actions === */

	// load entire layout
	LAYOUT_LOAD_SUCCESS = "LAYOUT_LOAD_SUCCESS",

	LAYOUT_SAVE_SUCCESS = "LAYOUT_SAVE_SUCCESS",

	LAYOUT_PANEL_ADD = "LAYOUT_PANEL_ADD",

	LAYOUT_PANEL_REMOVE = "LAYOUT_PANEL_REMOVE",

	LAYOUT_PANEL_MOVE = "LAYOUT_PANEL_MOVE",
	LAYOUT_PANEL_SORT = "LAYOUT_PANEL_SORT",

	AJAX_CALL_BEGIN = "AJAX_CALL_BEGIN",
	AJAX_CALL_ERROR = "AJAX_CALL_ERROR",

	STARTUP_ERROR = "STARTUP_ERROR",

	// breadcrumbs
	BREADCRUMBS_UPDATE = "BREADCRUMBS_UPDATE",

	QUERY_PARAMS_UPDATE = "QUERY_PARAMS_UPDATE",
	QUERY_PARAMS_REPLACE = "QUERY_PARAMS_REPLACE",

	QUERY_FORCE_REFRESH = "QUERY_FORCE_REFRESH",

	EDIT_ACTIVE_SET = "EDIT_ACTIVE_SET", // set current editing thing

	EDIT_TOGGLE = "EDIT_TOGGLE",

	EDIT_PANEL_TOGGLE = "EDIT_PANEL_TOGGLE",

	EDIT_CHANGES_INCREMENT = "EDIT_CHANGES_INCREMENT",

	EDIT_LAYOUT_TOGGLE = "EDIT_LAYOUT_TOGGLE",

	EDIT_SETTINGS_UPDATE = "EDIT_SETTINGS_UPDATE",

	USER_LOAD_SUCCESS = "USER_LOAD_SUCCESS",

	// Cart Actions
	ADD_TO_CART = "ADD_TO_CART",

	UPDATE_CART = "UPDATE_CART",

	REMOVE_ITEM = "REMOVE_ITEM",

	CLEAR_CART = "CLEAR_CART",

	USER_LOCALE_SET = "USER_LOCALE_SET",

	USER_TIMEZONE_SET = "USER_TIMEZONE_SET",

	USER_CONDITION_SET = "USER_CONDITION_SET",

	USER_ALL_CONDITIONS_SET = "USER_ALL_CONDITIONS_SET",

	CONFIG_CONTEXT_PROPERTIES_SUCCESS = "CONFIG_CONTEXT_PROPERTIES_SUCCESS",

	UPDATE_ITEMS_TO_SHOW = "UPDATE_ITEMS_TO_SHOW",

	ADD_ITEMS_TO_CART = "ADD_ITEMS_TO_CART",

	SET_QUANTITY_IN_CART = "SET_QUANTITY_IN_CART",

	REMOVE_ITEMS_FROM_CART = "REMOVE_ITEMS_FROM_CART",

	REMOVE_QUANTITY_FROM_CART = "REMOVE_QUANTITY_FROM_CART",

	SHOW_CHECKOUT_DETAILS = "SHOW_CHECKOUT_DETAILS",

	SET_CART_ITEMS_GROUP_BUY = "SET_CART_ITEMS_GROUP_BUY",

	SET_DISCOUNT_RESPONSE = "SET_DISCOUNT_RESPONSE",

	SAVE_CART_USER_DETAILS = "SAVE_CART_USER_DETAILS",

	SAVE_SHIPPABLE_USER_DETAILS = "SAVE_SHIPPABLE_USER_DETAILS",

	RESET_CART = "RESET_CART",
	
	SAVE_FORUM_ID = "SAVE_FORUM_ID",
	
	SAVE_USER_PERMISSION = "SAVE_USER_PERMISSION",
}

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/core/actions/actionTypes.ts